const UPDATE_INTERVAL = 60 * 60 * 1000;
const MIN_CHECK_INTERVAL = 60 * 1000;

export function registerPwa() {
  if (
    !import.meta.env.PROD ||
    !window.isSecureContext ||
    !("serviceWorker" in navigator)
  )
    return;

  const register = async () => {
    try {
      const registration = await navigator.serviceWorker.register(
        `${import.meta.env.BASE_URL}sw.js`,
        {
          scope: import.meta.env.BASE_URL,
          updateViaCache: "none",
        },
      );
      let lastCheck = 0;

      const checkForUpdate = () => {
        if (
          !navigator.onLine ||
          document.visibilityState !== "visible" ||
          registration.installing ||
          Date.now() - lastCheck < MIN_CHECK_INTERVAL
        )
          return;

        lastCheck = Date.now();
        // A network failure is harmless; the next online/visible check retries.
        registration.update().catch(() => {});
      };

      window.setInterval(checkForUpdate, UPDATE_INTERVAL);
      window.addEventListener("online", checkForUpdate);
      document.addEventListener("visibilitychange", checkForUpdate);
      checkForUpdate();
      // No controllerchange reload: preserve forms and the current session.
    } catch (error) {
      // PWA availability must never prevent the regular web app from loading.
      // eslint-disable-next-line no-console
      console.warn("PWA registration failed", error);
    }
  };

  if (document.readyState === "complete") register().catch(() => {});
  else
    window.addEventListener(
      "load",
      () => {
        register().catch(() => {});
      },
      { once: true },
    );
}
